
import { Component, ElementRef, OnInit, Output, ViewChild,  } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { HttpEventType } from "@angular/common/http";
import moment from "moment";
import { Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, finalize, take, takeUntil } from "rxjs/operators";
import { AppConstants } from "src/app/app.constants";
import { DocumentsRepositoryService } from "src/app/services/documents-repository.service";
import { ShareDataService } from "src/app/services/share-data.service";
import { SnackBarService } from "src/app/services/snack-bar.service";
import { UserRepositoryService } from "src/app/services/user-repository.service";
import { ConfirmReplaceExistingDocumentComponent } from "src/app/shared/dialogs/confirm-replace-existing-document/confirm-replace-existing-document.component";
import { DocumentsDetails, DocumentsDetailsRawData, FolderStructure, SupplierDetails } from "src/app/shared/models/documents.model";
import { User } from "src/app/shared/models/user.model";
import { FoldersViewComponent } from "../folders-view/folders-view.component";
import { UploadDocumentsComponent } from "../upload-documents/upload-documents.component";
import { environment } from 'src/environments/environment';
import { UploadDocumentsDeleteDialogsComponent } from '../dialogs/upload-documents-delete-dialogs/upload-documents-delete-dialogs.component';

@Component({
  selector: "app-shared-documents",
  templateUrl: "./shared-documents.component.html",
  styleUrls: ["./shared-documents.component.scss"],
})
export class SharedDocumentsComponent implements OnInit {
  @ViewChild(UploadDocumentsComponent)
  uploadDocumentsComponent: UploadDocumentsComponent;
  @ViewChild(FoldersViewComponent)
  private foldersViewComponent: FoldersViewComponent;
  isOpenDrawer: boolean = false;
  isLoadingData: boolean;
  isUploading: boolean = false;
  uploadProgress: number = 0;
  supplierDetails: SupplierDetails;
  folderStructure: FolderStructure;
  uploadFileForm: UntypedFormGroup;
  additionalInformation: boolean;
  SPECIALCHARCOMMENTS: string = "^[-,& $ # ( ) _ :a-zA-Z0-9]*";
  MAINFOLDERS: string = "Main Folders";
  SPECIALCHAR: string = "^[-,:a-zA-Z0-9]*$";
  SPECIALCHARSuffix: string = "^[-,_a-zA-Z0-9]*$";
  SPECIALCHARheatlotbatch: string = "^[-,:a-zA-Z0-9]*$";
  filePathLocation: string;
  subFolderName: string;
  subFolderId: string;
  mainFolderId: string;
  fileEmited: File;
  editUploadedfile: Boolean;
  tooltipOptions: Object;
  documentsDetails!: DocumentsDetails[];
  editFileDetails: DocumentsDetailsRawData;
  generatedDocumentName: string;
  private unsubscribe: Subject<void> = new Subject<void>();
  allSuppliers: SupplierDetails[];
  gridShowHide: boolean = false;
  showSupplierSerchControl: boolean;
  isUserSupplier: boolean = false;
  supplierResults: SupplierDetails[];
  private user: User;
  loggedUserDetails: User;
  hasPermission: boolean = false;
  suppliersForm: UntypedFormGroup;
  toggleOptions: Array<String> = ["Folders", "Search"];
  toggleSelected: String[] = ["Folders"];
  searchGrid: boolean;
  foldersGrid: boolean;
  folderToggleFlag: boolean;
  searchToggleFlag: boolean;
  breadCrumb: string[];
  folderIcon: boolean = true;
  searchIcon: boolean = false;
  environmentName: string;
  showDeleteBtn: boolean = false;
  isDeleteRecordConfirm: boolean = false;
  updateUndoButtonInfo: boolean;
  isNotification:boolean=false;
  notificationSelectedDoc:string;
  tagsListEvent: any;
  refreshDocumentSearchGrid: string;
  docTypeSelected: any;

  // @Output() isOpenDrawer =  new EventEmitter();

  constructor(
    private documentsService: DocumentsRepositoryService,
    private snackBarService: SnackBarService,
    public fb: UntypedFormBuilder,
    public dialog: MatDialog,
    private userRepositoryService: UserRepositoryService, 
    private shareDataService:ShareDataService
  ) {}

  ngOnInit(): void {
    this.environmentName = environment.envt;
    //this.getfolderStructureData();
   // this.getAllGetSuppliers();
   this.checkLoggedUserRole();
    this.getValidFileExtensions();
    this.initForms();
    this.supplierInitForms();
    this.foldersGrid = true;
    this.searchGrid = false;
    this.folderToggleFlag = true;
    this.shareDataService.getUndoButtonInfo().pipe(takeUntil(this.unsubscribe))
    .subscribe(info => {
      this.updateUndoButtonInfo = info;
      if(this.updateUndoButtonInfo) {
        this.revertDeletedRecord();
      }
    });
    this.closeAppSettingsDrawer();
  }

  ngAfterViewInit(): void{ }

  revertDeletedRecord() {
    this.documentsService.getUndoSolarFormRecord(this.editFileDetails.fileId)
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(data => {
      if(data){
        this.isDeleteRecordConfirm = true;
        this.foldersViewComponent.uploadLocation(this.editFileDetails.filePath, this.isDeleteRecordConfirm);
      }
    });
  }

  selectedToggle(event) {
    if (event === "Folders") {
      this.folderIcon = true;
      this.searchIcon = false;
      this.foldersGrid = true;
      this.searchGrid = false;
      this.folderToggleFlag = true;
      this.searchToggleFlag = false;
      this.suppliersForm.controls.supplier.value?this.gridShowHide = true:this.gridShowHide = false;
     
     }
  }
  
  searchToggle(event) {
    if (event === "Search") {
      this.folderIcon = false;
      this.searchIcon = true;
      this.searchGrid = true;
      this.foldersGrid = false;
      this.searchToggleFlag = true;
      this.folderToggleFlag = false;
      this.gridShowHide = false;
     
    }
  }
 
  openDialog() {
    this.uploadDocumentsComponent.suffixWarning;
    const dialogRef = this.dialog.open(
      ConfirmReplaceExistingDocumentComponent,
      {
        data: {
          name: this.uploadDocumentsComponent.generatedDocumentNameValue,
        },
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      result
        ? this.saveFormAfterValid()
        : (this.uploadDocumentsComponent.suffixWarning = true);
    });
  };

  parentEventHandlerFunction(valueEmitted: File) {
    this.fileEmited = valueEmitted;
  };

  dateComparator(date1: string, date2: string): number {
    return new Date(date1) < new Date(date2) ? -1 : 1;
  };

  private initForms() {
    this.uploadFileForm = this.fb.group({
      supplier: ["", Validators.required],
      searchBox: [""],
      filesToUpload: [""],
      documentType: ["", Validators.required],
      documentName: [""],
      tags: ["", Validators.maxLength(20)],
      documentNameSuffix: ["",[Validators.maxLength(10), Validators.pattern(this.SPECIALCHARSuffix)],],
      comments: ["",[Validators.maxLength(500), Validators.pattern(this.SPECIALCHARCOMMENTS),
        ],
      ],
    });

    if (this.isUserSupplier) {
      this.uploadFileForm.controls.supplier.updateValueAndValidity();
    }
    // added for reformatting DocumentName
    this.uploadFileForm.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((x) => {
        this.generatedDocumentName = this.generatingDocumentName();
      });
    this.uploadFileForm.controls.supplier.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((objSup) => {
        if (objSup) {          
          this.suppliersForm.controls.supplier.setValue(objSup);
          this.supplierDetails = objSup;
          this.getSupplierSelectedHandler(this.supplierDetails);
        }
      });
  };


  ondocTypeSelected(event) {
    this.docTypeSelected = event;
    this.uploadDocumentsComponent.isCommonControlsAvailable = true;
  }

  hasBlockingFormErrors(): boolean {
    if (!this.uploadFileForm) {
      return false;
    }

    return Object.keys(this.uploadFileForm.controls).some((controlName) => {
      const control = this.uploadFileForm.controls[controlName];
      if (!control || !control.invalid) {
        return false;
      }

      if (controlName !== 'solarPartNumber') {
        return true;
      }

      const errors = control.errors || {};
      const hasOnlyMaxLengthError = Object.keys(errors).length === 1 && !!errors.maxlength;
      return !hasOnlyMaxLengthError;
    });
  }

  onTagsEventHandler(event) {
    this.tagsListEvent = event;
  }

  private getFolderSubfolderId(selectedValue: string): void {
    this.folderStructure.folderStructure.forEach((folderElement) => {
      folderElement.subFolders.forEach((subfolderElement) => {
        if(!subfolderElement.documentType){
          this.checkNestedSubFolders(subfolderElement, selectedValue, folderElement);
        } else {
        subfolderElement.documentType.filter((element) => {
          if (element.documentTypeName === selectedValue) {
            // this.uploadDocumentsComponent.filePathToUpload=`${folderElement.folderName}\\${subfolderElement.subFolderName}`
            this.subFolderName = subfolderElement.subFolderName;
            this.subFolderId = subfolderElement.subFolderId.toString();
            this.mainFolderId = folderElement.folderId.toString();
            return false;
          }
        });
        }
      });
    });
  };

  private checkNestedSubFolders(subfolderElement, selectedValue, folderElement): void {
    if(!subfolderElement.subFolders) { return; }

    subfolderElement.subFolders.forEach((nestedSubFolder) => {
      if(nestedSubFolder.documentType) {
        nestedSubFolder.documentType.filter((element) => {
          if (element.documentTypeName === selectedValue) {
            this.subFolderName = nestedSubFolder.subFolderName;
            this.subFolderId = nestedSubFolder.subFolderId.toString();
            this.mainFolderId = folderElement.folderId.toString();
            return false;
          }
        });
      }
    });

  }

  setInitEditDetails(): void { 
    let list = [];
    let tagsValue = this.editFileDetails.uiDocumentAttributesDTO.documentAttributes.additionalInformation.tags[0];
    if(tagsValue != null && tagsValue != 'undefined') {
      list = this.editFileDetails.uiDocumentAttributesDTO.documentAttributes.additionalInformation.tags[0].split(',');
      this.uploadDocumentsComponent.documentTag = [];
      this.uploadDocumentsComponent.documentTag = list;
    }   
    this.uploadFileForm.controls.supplier.patchValue(this.supplierDetails);
    this.uploadDocumentsComponent.uploadFileName = this.editFileDetails.documentName;
    this.uploadDocumentsComponent.editFileMode = true;
    this.mainFolderId = this.editFileDetails.mainFolderId.toString();
    if(this.editFileDetails.subFolderId != null){
      this.subFolderId = this.editFileDetails.subFolderId.toString();
    }
   
    this.uploadFileForm.controls.comments.patchValue(this.editFileDetails.comments);
    this.uploadFileForm.controls.documentName.patchValue(this.editFileDetails.documentName);
    this.uploadFileForm.controls.documentNameSuffix.patchValue(this.editFileDetails.uiDocumentAttributesDTO.documentAttributes.documentSuffix);
  };

  private getFormData() {
    const allFormControls = this.uploadFileForm.controls;
    let formData: FormData = new FormData();
    formData.append("supplierId", this.supplierDetails.id);
    formData.append("fileName", allFormControls.documentName.value);
    formData.append("DocumentType", this.uploadDocumentsComponent?.selectedDocTypes[0]?.documentTypeString);
    formData.append("file", this.fileEmited);
    allFormControls.documentNameSuffix.value === null || '' ? formData.append("documentSuffix", ""): formData.append("documentSuffix",allFormControls.documentNameSuffix.value);
    allFormControls.comments.value === null? formData.append("comments", ""):formData.append("comments", allFormControls.comments.value);
    formData.append("subFolderId", this.subFolderId);
    formData.append("tags", allFormControls.tags ||
    (this.uploadFileForm.controls.tags.value.length <= 20) ?  this.tagsListEvent :
      this.tagsListEvent.length == 0 ? '' :  this.tagsListEvent );
    formData.append("commonExpirationDate", allFormControls.commonExpirationDate?allFormControls.commonExpirationDate.value.toString().split('G')[0]:'');
    formData.append("commonIsIntegratedWithSSS", allFormControls.commonIsIntegratedWithSSS?allFormControls.commonIsIntegratedWithSSS.value:'');
    formData.append("mainFolderId", this.mainFolderId);
    formData.append("solarPartNumber", allFormControls.solarPartNumber?allFormControls.solarPartNumber.value:'');
    formData.append("serialNumber", allFormControls.serialNumber?allFormControls.serialNumber.value:'');
    formData.append("purchaseOrder", allFormControls.purchaseOrder?allFormControls.purchaseOrder.value:'');
    formData.append("typeofCertification", allFormControls.typeofCertification ? allFormControls.typeofCertification.value : '');
    formData.append("shipmentDate", allFormControls.shipmentDate?allFormControls?.shipmentDate?.value.toString().split('G')[0]:'');
    formData.append("invoiceDate", allFormControls.invoiceDate?allFormControls.invoiceDate.value.toString().split('G')[0]:'');
    formData.append("invoiceNumber", allFormControls.invoiceNumber?allFormControls.invoiceNumber.value:'');
    formData.append("heatLotNumber", allFormControls.heatLotNumber?allFormControls.heatLotNumber.value:'');
    formData.append("batchNumber", allFormControls.batchNumber?allFormControls.batchNumber.value:'');
    formData.append("materialComposition", allFormControls.materialComposition?allFormControls.materialComposition.value:'');
    formData.append("leakTest", allFormControls.leakTest?allFormControls.leakTest.value:'');
    formData.append("rTANumber", allFormControls.rtaNumber?allFormControls.rtaNumber.value:'');
    formData.append("pPAPNumber", allFormControls.ppapNumber?allFormControls.ppapNumber.value:'');
    formData.append("pPAPLevel", allFormControls.ppapLevel?allFormControls.ppapLevel.value:'');
    formData.append("typeOfClaim", allFormControls.typeOfClaim?allFormControls.typeOfClaim.value:'');
    formData.append("pPRNUmber", allFormControls.pprnUmber?allFormControls.pprnUmber.value:'');
    formData.append("typeofAlert", allFormControls.typeofAlert?allFormControls.typeofAlert.value:'');
    formData.append("termsOfConditions", allFormControls.termsOfConditions?allFormControls.termsOfConditions.value:'');
    formData.append("deviations", allFormControls.deviations?allFormControls.deviations.value === null ? false : allFormControls.deviations.value : '');
    formData.append("valueStream", allFormControls.valueStream?allFormControls.valueStream.value:'');
    formData.append("effectivityDate", allFormControls.effectivityDate?allFormControls.effectivityDate?.value.toString().split('G')[0]:'');
    formData.append("expirationDate", allFormControls.expirationDate?allFormControls.expirationDate?.value.toString().split('G')[0]:'');
    formData.append("expirationFlag", allFormControls.expirationFlag?allFormControls.expirationFlag.value:'');
    formData.append("intellectualProperty", allFormControls.intellectualProperty?allFormControls.intellectualProperty.value: '');
    formData.append("exclusivityAgreements", allFormControls.exclusivityAgreements?allFormControls.exclusivityAgreements.value === null ? false:allFormControls.exclusivityAgreements.value: '');
    formData.append("effectivity", allFormControls.effectivity?allFormControls.effectivity.value:'');
    formData.append("expiration", allFormControls.expiration?allFormControls.expiration.value === null ? false : allFormControls.expiration.value : '');
    formData.append("commodity", allFormControls.commodity?allFormControls.commodity.value:'');
    formData.append("serviceType", allFormControls.serviceType?allFormControls.serviceType.value:'');
    formData.append("workAtCustomerSite", allFormControls.workAtCustomerSite?allFormControls.workAtCustomerSite.value:'');
    formData.append("revisionNumber", allFormControls.revisionNumber?allFormControls.revisionNumber.value:'');
    formData.append("preassureTest", allFormControls.preassureTest?allFormControls.preassureTest.value:'');
    formData.append("dueDate",allFormControls.dueDate?allFormControls.dueDate.value.toString().split('G')[0]:'');
    formData.append("month", allFormControls.month?allFormControls.month.value:'');
    formData.append("year", allFormControls.year?allFormControls.year.value:'');
    formData.append("timeFrame", allFormControls.timeFrame?allFormControls.timeFrame.value.toString().split('G')[0]:'');
    formData.append("projectNumber", allFormControls.projectNumber?allFormControls.projectNumber.value:'');
    formData.append("weight", allFormControls.weight?allFormControls.weight.value:'');
    formData.append("dimensions", allFormControls.dimensions?allFormControls.dimensions.value:'');
    formData.append("numberOfContainers", allFormControls.numberOfContainers?allFormControls.numberOfContainers.value:'');
    formData.append("quantity", allFormControls.quantity?allFormControls.quantity.value:'');
    formData.append("pickUpDate", allFormControls.pickUpDate?allFormControls.pickUpDate.value.toString().split('G')[0]:'');
    formData.append("deliveryDate", allFormControls.deliveryDate?allFormControls.deliveryDate.value.toString().split('G')[0]:'');
    formData.append("trackingNumber", allFormControls.trackingNumber?allFormControls.trackingNumber.value:'');
    formData.append("shippedQuantity", allFormControls.shippedQuantity?allFormControls.shippedQuantity.value:'');
    formData.append("damagedQuantity", allFormControls.damagedQuantity?allFormControls.damagedQuantity.value:'');
    formData.append("valueOfClaim", allFormControls.valueOfClaim?allFormControls.valueOfClaim.value:'');
    formData.append("descriptionOfMaterial", allFormControls.descriptionOfMaterial?allFormControls.descriptionOfMaterial.value:'');
    formData.append("damageDescription", allFormControls.damageDescription?allFormControls.damageDescription.value:'');
    formData.append("descriptionOfDocument", allFormControls.descriptionOfDocument?allFormControls.descriptionOfDocument.value:'');
    formData.append("dateOfPresentation", allFormControls.dateOfPresentation?allFormControls.dateOfPresentation.value.toString().split('G')[0]:'');
    formData.append("rNNumber", allFormControls.rnNumber?allFormControls.rnNumber.value:'');
    formData.append("rmaNumber", allFormControls.rmaNumber?allFormControls.rmaNumber.value:'');
    formData.append("pdNumber", allFormControls.pdNumber?allFormControls.pdNumber.value:'');
    formData.append("tcNumber", allFormControls.tcNumber?allFormControls.tcNumber.value:'');
    formData.append("icmNumber", allFormControls.icmNumber?allFormControls.icmNumber.value:'');
    formData.append("netWeightLbs", allFormControls.netWeightLbs?allFormControls.netWeightLbs.value:'');
    formData.append("grossWeightLbs", allFormControls.grossWeightLbs?allFormControls.grossWeightLbs.value:'');
    formData.append("loadTestRequired", allFormControls.loadTestRequired?allFormControls.loadTestRequired.value:'');
    formData.append("actualLoadTestWeightLbs", allFormControls.actualLoadTestWeightLbs?allFormControls.actualLoadTestWeightLbs.value:'');
    formData.append("ratedLiftCapacityLbs", allFormControls.ratedLiftCapacityLbs?allFormControls.ratedLiftCapacityLbs.value:'');
    formData.append("pressureTestRequired", allFormControls.pressureTestRequired?allFormControls.pressureTestRequired.value:'');
    formData.append("pressurePsi", allFormControls.pressurePsi?allFormControls.pressurePsi.value:'');
    formData.append("sII", allFormControls.sii?allFormControls.sii.value:'');
    formData.append("cARCORNumber", allFormControls.cARCORNumber?allFormControls.cARCORNumber.value:''); 
    formData.append("manufacturerName", allFormControls.manufacturerName?allFormControls.manufacturerName.value:'');  
    formData.append("documentExpirationDate", allFormControls.documentExpirationDate?allFormControls.documentExpirationDate.value.toString().split('G')[0]:'');
    return formData;
  };
  // the method reformats Document Name
  generatingDocumentName(): string {   
    let extension: any;
     let ext: any;  
     ext = this.uploadDocumentsComponent.uploadFileName.lastIndexOf('.'); 
    //  extension = this.uploadDocumentsComponent.uploadFileName.substring( ext); 
    extension = this.uploadDocumentsComponent.uploadFileName.lastIndexOf( ext); 

    !this.uploadDocumentsComponent.uploadFileName? (extension = ""): (extension =this.uploadDocumentsComponent.uploadFileName.substring( ext));
    if (this.editFileDetails?.documentName){
      extension = this.editFileDetails?.documentName?.split(".")[1]; 
      extension = extension ? "." + extension : "";
    };
      
    if (this.editFileDetails?.documentName && this.uploadDocumentsComponent.uploadFileName) {
        // extension = this.uploadDocumentsComponent.uploadFileName.split(".")[1];
      extension = this.uploadDocumentsComponent.uploadFileName.substring( ext+1); 
      extension = extension ? "." + extension : "";
      };
    const allFormControls = this.uploadFileForm.controls;
    let replacedRangePurchaseOrder: string = "";
    let replacedRangeSolarPartNumber: string = "";
    let replacedRangeSolarSerialNumber: string = "";
    let result: string = "";

    // document type selection case
    result +=this.fileEmited || this.editFileDetails? allFormControls.documentType.value && this.uploadDocumentsComponent.selectedDocTypes[0]?.documentTypeString
          ? `${this.uploadDocumentsComponent.selectedDocTypes[0]?.shortCode}` +"_" + this.supplierDetails.organizationCode: this.supplierDetails.organizationCode: "";

    //date format, mandatory
    result +=this.fileEmited || this.editFileDetails ? "_" +moment(new Date().toUTCString()).format("MMMDDyyyy").toUpperCase(): "";
    // Purchase Order (PO)
   if (allFormControls.purchaseOrder && allFormControls.purchaseOrder.value || this.uploadDocumentsComponent.additionalInfoObj.purchaseOrderNumber) {
      let purchaseOrderSubstring: string = "";
      // replace ':' to '~'
      replacedRangePurchaseOrder = allFormControls.purchaseOrder.value.includes(":")
        ? allFormControls.purchaseOrder.value.replace(/:/g, "~")
        : allFormControls.purchaseOrder.value;
      let firstIndexVal = replacedRangePurchaseOrder.includes(",")
        ? replacedRangePurchaseOrder.indexOf(",")
        : undefined;
      purchaseOrderSubstring = replacedRangePurchaseOrder.includes(",")
        ? replacedRangePurchaseOrder.substring(0, firstIndexVal)
        : replacedRangePurchaseOrder;
      result +=this.fileEmited || this.editFileDetails? "_" + purchaseOrderSubstring: "";
    } else {
      result += "";
    }
    // Solar Part Number (PN)
    if (allFormControls.solarPartNumber && allFormControls.solarPartNumber.value ||this.uploadDocumentsComponent.additionalInfoObj.solarPartNumber) {
      let solarPartNumberSubstring: string = "";
      // replace ':' to '~'
      replacedRangeSolarPartNumber =allFormControls.solarPartNumber.value.includes(":")
          ? allFormControls.solarPartNumber.value.replace(/:/g, "~")
          : allFormControls.solarPartNumber.value;
      let firstIndexVal = replacedRangeSolarPartNumber.includes(",")
        ? replacedRangeSolarPartNumber.indexOf(",")
        : undefined;
      solarPartNumberSubstring = replacedRangeSolarPartNumber.includes(",")
        ? replacedRangeSolarPartNumber.substring(0, firstIndexVal)
        : replacedRangeSolarPartNumber;
      result +=this.fileEmited || this.editFileDetails? "_" + solarPartNumberSubstring: "";
    } else {
      result += "";
    }
    // Serial number (SN) "serialNumber"
    if (allFormControls.serialNumber && allFormControls.serialNumber.value || this.uploadDocumentsComponent.additionalInfoObj.serialNumber) {
      let solarSerialNumberSubstring: string = "";
      // replace ':' to '~'
      replacedRangeSolarSerialNumber =
        allFormControls.serialNumber.value.includes(":")
          ? allFormControls.serialNumber.value.replace(/:/g, "~")
          : allFormControls.serialNumber.value;
      let firstIndexVal = replacedRangeSolarSerialNumber.includes(",")
        ? replacedRangeSolarSerialNumber.indexOf(",")
        : undefined;
      solarSerialNumberSubstring = replacedRangeSolarSerialNumber.includes(",")
        ? replacedRangeSolarSerialNumber.substring(0, firstIndexVal)
        : replacedRangeSolarSerialNumber;
      result +=this.fileEmited || this.editFileDetails? "_" + solarSerialNumberSubstring : "";
    } else {
      result += "";
    }
    //PPAP Number
    if (allFormControls.pPAPNumber && allFormControls.pPAPNumber.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.pPAPNumber.value : "";
    };

    //PPR Number
    if (allFormControls.pPrNumber && allFormControls.pPrNumber.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.pPrNumber.value.trim() : "";
    };

    //Type of Alert
    if (allFormControls.typeofAlert && allFormControls.typeofAlert.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.typeofAlert.value.trim() : "";
    };

    //type of  Terms of Conditions
    if (allFormControls.typeofTermsofConditions && allFormControls.typeofTermsofConditions.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.typeofTermsofConditions.value.trim() : "";
    };

    //type of  Terms of Conditions
    if (allFormControls.typeofTermsofConditions && allFormControls.typeofTermsofConditions.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.typeofTermsofConditions.value.trim() : "";
    };

    //Commodity
    if (allFormControls.commodity && allFormControls.commodity.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.commodity.value.trim() : "";
    };

    //commodityOrServices
    if (allFormControls.commodityOrServices && allFormControls.commodityOrServices.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.commodityOrServices.value.trim() : "";
    };

    //Service Type
    if (allFormControls.serviceType && allFormControls.serviceType.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.serviceType.value.trim() : "";
    };

    //Effectivity Date
    if (allFormControls.effectivityDate && allFormControls.effectivityDate.value){
      result +=this.fileEmited || this.editFileDetails? "_" + +moment(allFormControls.effectivityDate.value).format("MMMDDyyyy").toUpperCase(): "";
    };

    //Date of Presentation 
    if (allFormControls.dateofPresentation  && allFormControls.dateofPresentation.value){
       result +=this.fileEmited || this.editFileDetails? "_" + +moment(allFormControls.dateofPresentation.value).format("MMMDDyyyy").toUpperCase(): "";
    };
    //Effectivity Date
    if (allFormControls.dueDate && allFormControls.dueDate.value){
      result +=this.fileEmited || this.editFileDetails? "_" + +moment(allFormControls.dueDate.value).format("MMMDDyyyy").toUpperCase(): "";
    }

    //Revision Number
    if (allFormControls.revisionNumber && allFormControls.revisionNumber.value){
      result +=this.fileEmited || this.editFileDetails? "_" + (allFormControls.revisionNumber.value.includes(",") ? allFormControls.revisionNumber.value.split(",")[0] : allFormControls.revisionNumber.value): "";
    };

    //month
    if (allFormControls.month && allFormControls.month.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.month.value.trim() : "";
    };

    //year
    if (allFormControls.year && allFormControls.year.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.year.value.trim() : "";
    };

    //Project Number 
    if (allFormControls.projectNumber && allFormControls.projectNumber.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.projectNumber.value : "";
    };

    //Type of Claim 
    if (allFormControls.typeofClaim && allFormControls.typeofClaim.value){
      result +=this.fileEmited || this.editFileDetails? "_" + allFormControls.typeofClaim.value.trim() : "";
    };
    
     //Invoice Date
     if (allFormControls.invoiceDate && allFormControls.invoiceDate.value){
      result +=this.fileEmited || this.editFileDetails? "_" + moment(allFormControls.invoiceDate.value).format("MMMDDyyyy").toUpperCase(): "";
    }

    //  //Shipment Date
    //  if (allFormControls.shipmentDate && allFormControls.shipmentDate.value){
    //   result +=this.fileEmited || this.editFileDetails? "_" + moment(allFormControls.shipmentDate.value).format("MMMDDyyyy").toUpperCase(): "";
    // }

    

    // Document Name Suffix
    result += allFormControls.documentNameSuffix.value ? this.fileEmited || this.editFileDetails ? "_" + allFormControls.documentNameSuffix.value: "": "";
    // Adding extension for the document name
    result += extension;
    // replacing final document name label
    allFormControls.documentName.patchValue(result);
    this.uploadDocumentsComponent.generatedDocumentNameValue = result;
    return result;
  };
  //click events handler code start here
  openDrawerHandler(e) {
    this.setResetBreadcrumb();
    this.uploadDocumentsComponent.editFileMode = this.editUploadedfile = false;
    this.isOpenDrawer = true;
    this.uploadFileForm.controls.documentType.patchValue("");
    this.uploadDocumentsComponent.isEditCommonControls = false;
    this.uploadDocumentsComponent.onUploadclicked();
    this.userRepositoryService.closeNotification.next(true);
    this.userRepositoryService.appSettingsClose.next(true);
    this.userRepositoryService.isUploadDrawerClose.next(false);
  };

  private closeAppSettingsDrawer(){
    this.userRepositoryService.isUploadDrawerClose.pipe(
      takeUntil(this.unsubscribe)).subscribe(value=>{
      if(value){
       this.isOpenDrawer = false;
      }
    })
    }


 
  editFormHandler(id: string) {
    this.setResetBreadcrumb();
    this.documentsService.breadCrumb$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: string[]) => {
        this.breadCrumb = data;
      });
    this.documentsService
      .getUploadedFilesById(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (editFileResponse: DocumentsDetailsRawData) => {
          if (this.searchGrid) {
            this.supplierDetails = this.allSuppliers.find(
              (x) => x.id === editFileResponse.supplierId
            );
            this.uploadDocumentsComponent.supplierInfo=this.supplierDetails;
          }
          this.editDetailsHandler(editFileResponse);
        },
        (err) => {
          this.snackBarService.showError(err);
        }
      );
  };

  editOpenDrawerHandler(): void {
    this.editUploadedfile = true;
    this.isOpenDrawer = true;

    this.uploadDocumentsComponent.onUploadclicked();
  };
  
  uploadFileHandler(): void {
    if (this.uploadDocumentsComponent.hasPermissions) {
      if (this.uploadDocumentsComponent.fileSizeValid) {
        this.snackBarService.showError(`File exceeds the maximum upload size of ${this.uploadDocumentsComponent.fileSize}MB. Please select a smaller file.`);
        return;
      }
      if (
        this.uploadFileForm.invalid ||
        !this.uploadFileForm.dirty ||
        this.uploadDocumentsComponent.invalidDocType || 
        this.uploadDocumentsComponent.invalidMaterial
      ) {
        this.uploadFileForm.markAllAsTouched();
      } else {
        this.uploadFileForm.markAsUntouched();
        this.isDocumentExit();
      }
    }
  }
  editUploadFileHandler(): void {
    if (this.uploadDocumentsComponent.hasPermissions) {
      if (this.uploadDocumentsComponent.fileSizeValid) {
        this.snackBarService.showError(`File exceeds the maximum upload size of ${this.uploadDocumentsComponent.fileSize}MB. Please select a smaller file.`);
        return;
      }
      if (
        this.uploadFileForm.invalid ||
        !this.uploadFileForm.dirty ||
        this.uploadDocumentsComponent.invalidDocType || this.uploadDocumentsComponent.invalidMaterial
      ) {
        this.uploadFileForm.markAllAsTouched();
      } else {
        this.isDocumentExit();
      }
    }
  }
  drawerCloseHandler() {
    this.isOpenDrawer = false;
    this.uploadDocumentsComponent.documentTag = [];
    // this.uploadFileForm.reset();
    this.uploadDocumentsComponent.uploadFileName = "";
    this.uploadDocumentsComponent.fileList = [];
    this.uploadDocumentsComponent.selectedDocTypes = [];
    this.uploadDocumentsComponent.generatedDocumentNameValue = "";
    if (this.editFileDetails?.documentName)
      this.editFileDetails.documentName = "";
      this.uploadFileForm.controls.documentType.patchValue("");
      this.uploadFileForm.controls.documentNameSuffix.reset('');
      this.uploadFileForm.controls.comments.reset();
      //this.uploadDocumentsComponent.docTypesByPath.filterList = [];
      if (this.uploadDocumentsComponent.docTypesByPath) {
        this.uploadDocumentsComponent.docTypesByPath.item1 = [];
        this.uploadDocumentsComponent.docTypesByPath.item2 = [];
      }
      this.uploadDocumentsComponent.suffixWarning = false;
      this.uploadDocumentsComponent.editFileMode = false;
      this.uploadDocumentsComponent.fileSizeValid = false;
      this.uploadDocumentsComponent.mutipleFilesNotAllowed = false;
      this.fileEmited = undefined;
      this.uploadDocumentsComponent.resetDynamicFormFields();
      this.uploadDocumentsComponent.resetDynamicCommonFormFields();
      this.uploadFileForm.updateValueAndValidity();
  }

  deleteDocumentHandler(){
    const dialogRef = this.dialog.open(UploadDocumentsDeleteDialogsComponent, {
      data: { documentName : this.uploadDocumentsComponent.uploadFileName }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
      this.documentsService.softDeleteSolarForm(this.editFileDetails.fileId)
      .subscribe(resp => {
        if(resp===true){
          this.isDeleteRecordConfirm = true;
          this.foldersViewComponent.uploadLocation(this.editFileDetails.filePath, this.isDeleteRecordConfirm);
          this.snackBarService.showSuccess(AppConstants.deletedDocSuccessMsg, true);
          this.drawerCloseHandler();
        }
        else{
          this.snackBarService.showError(AppConstants.deletedDocErrorsMsg);
          this.drawerCloseHandler();
        }
      });
     }
    });
  }
 
  resetFormValue() {
    this.uploadFileForm.controls.comments.patchValue("");
    this.uploadFileForm.controls.tags.patchValue("");
    this.uploadFileForm.controls.documentName.patchValue("");
    this.uploadFileForm.controls.solarPartNumber.patchValue("");
    this.uploadFileForm.controls.solarSerialNumber.patchValue("");
    this.uploadFileForm.controls.purchaseOrder.patchValue("");
    this.uploadFileForm.controls.documentNameSuffix.patchValue("");
    this.uploadFileForm.controls.batch.patchValue("");
    this.uploadFileForm.controls.shipmentDate.patchValue("");
    this.uploadFileForm.controls.heatLot.patchValue("");
    this.uploadFileForm.controls.material.patchValue("");
    this.uploadFileForm.controls.supplier.patchValue("");
  }

  editDetailsHandler(editFileResponse: DocumentsDetailsRawData) {
    this.editFileDetails = editFileResponse;
    this.uploadDocumentsComponent.editFileDetailsChildComponents =editFileResponse;
    this.uploadDocumentsComponent.isEditCommonControls = true;
    this.setInitEditDetails();
    this.editOpenDrawerHandler();
  }

  saveAddFileForm() {
    const seletecdValue = this.uploadDocumentsComponent.selectedDocTypes[0].documentTypeString;
    this.getFolderSubfolderId(seletecdValue);
    if (this.uploadFileForm.valid) {
      this.isUploading = true;
      this.uploadProgress = 0;
      this.documentsService
        .uploadSolarForm(this.getFormData())
        .pipe(
          takeUntil(this.unsubscribe),
          finalize(() => { this.isUploading = false; this.uploadProgress = 0; })
        )
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.uploadProgress = event.total
                ? Math.round((100 * event.loaded) / event.total)
                : 0;
            } else if (event.type === HttpEventType.Response) {
              const response = event.body;
              const isSuccess = response?.success ?? response?.Success;
              if (isSuccess) {
                const folderPath = response.folderPath ?? response.FolderPath;
                this.foldersViewComponent.uploadLocation(folderPath);
                this.snackBarService.showSuccess(AppConstants.uploadedDocSuccessMsg);
                this.drawerCloseHandler();
              } else {
                console.warn('Upload response did not indicate success:', JSON.stringify(response));
                this.snackBarService.showError(response?.message ?? response?.Message ?? AppConstants.uploadMsgError);
              }
            }
          },
          (error) => {
            if (error.status == 405) {
              this.uploadFileForm.controls.filesToUpload.setErrors({ invalidExt: true });
            } 
            else if(error.status==400){
              this.snackBarService.showError(error?.error?.message ?? error?.error ?? "Invalid input!");
            }
            else {
                  this.snackBarService.showError(this.getUploadErrorMessage(error, AppConstants.updatedMsgError));
              this.drawerCloseHandler();
            }
          }
        );
    } else {
      this.isUploading = false;
    }
  }

  saveEditFileForm() {
    const seletecdValue =this.uploadDocumentsComponent.selectedDocTypes[0].documentTypeString;   
    this.getFolderSubfolderId(seletecdValue);
    if (this.uploadFileForm.valid) {
      this.isUploading = true;
      this.uploadProgress = 0;
      this.documentsService
        .editUploadSolarForm(this.getFormData(), this.editFileDetails.fileId)
        .pipe(
          takeUntil(this.unsubscribe),
          finalize(() => { this.isUploading = false; this.uploadProgress = 0; })
        )
        .subscribe(
          (event) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.uploadProgress = event.total
                ? Math.round((100 * event.loaded) / event.total)
                : 0;
            } else if (event.type === HttpEventType.Response) {
              const response = event.body;
              const isSuccess = response?.success ?? response?.Success;
              if (isSuccess) {
                const folderPath = response.folderPath ?? response.FolderPath;
                if (!this.searchGrid) {
                  this.foldersViewComponent.uploadLocation(folderPath);
                  this.refreshDocumentSearchGrid = "refresh document search grid";
                }
                this.snackBarService.showSuccess(AppConstants.updatedDocDetSuccessMsg);
                this.drawerCloseHandler();
                this.refreshDocumentSearchGrid = "refresh document search grid"
              } else {
                console.warn('Edit upload response did not indicate success:', JSON.stringify(response));
                this.snackBarService.showError(response?.message ?? response?.Message ?? AppConstants.updatedMsgError);
              }
            }
          },
          (error) => {
            if (error.status == 405) {
              this.uploadFileForm.controls.filesToUpload.setErrors({ invalidExt: true });
            } 
            else if(error.status==400){
              this.snackBarService.showError(error?.error?.message ?? error?.error ?? "Invalid input!");
            }
            else {
                  this.snackBarService.showError(this.getUploadErrorMessage(error, AppConstants.updatedMsgError));
              this.drawerCloseHandler();
            }
          }
        );
    } else {
      this.isUploading = false;
    }
  }

  isDocumentExit(): void {
    this.documentsService
      .isDocumentExit(this.generatedDocumentName, this.supplierDetails.id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((response: Boolean) => {
        response ? this.openDialog() : this.saveFormAfterValid();
      });
  }

  saveFormAfterValid(): void {
    this.uploadDocumentsComponent.editFileMode
      ? this.saveEditFileForm()
      : this.saveAddFileForm();
  };

//  private  getAllGetSuppliers():void  {
//     this.documentsService
//       .getAllSuppliers()
//       .pipe(takeUntil(this.unsubscribe))
//       .subscribe(
//         (response) => {
//           const res: any = response;          
//           this.allSuppliers = res;
//           this.shareDataService.emitAllSupplier(this.allSuppliers);
//           this.supplierResults = this.allSuppliers;
//           this.uploadDocumentsComponent.allSuppliers = this.allSuppliers;
//           this.checkLoggedUserRole();
//           this.registerNotificationView();
//         },
//         (error) => {
//           this.snackBarService.showError(error.message);
//         }
//       );
//   };

  private getValidFileExtensions(): void {
    this.documentsService
      .getValidFileExtensions()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          this.uploadDocumentsComponent.acceptedFileExtensions =
            response.toString();
        },
        (error) => {
          this.snackBarService.showError(error.message);
        }
      );
  };

  private getUploadErrorMessage(error: any, fallback: string): string {
    if (!error) {
      return fallback;
    }

    if (typeof error.error === 'string' && error.error.trim().length > 0) {
      return error.error;
    }

    if (error.error?.message && typeof error.error.message === 'string') {
      return error.error.message;
    }

    if (error.message && typeof error.message === 'string') {
      return error.message;
    }

    return fallback;
  }

  private checkLoggedUserRole(): void {
    this.userRepositoryService.loggedUserData$
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((user: User) => {  
        this.user = user;     
        this.userRepositoryService.getSuppliersByUserId(user.cwsId)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          const supplierFiltered = res.filter(function (el) {
            return el != null;
          });
          
          this.supplierResults = supplierFiltered;
          this.allSuppliers = this.supplierResults;
          this.registerNotificationView();
        });

        if (user.roleId === AppConstants.Supplier) {
          // let getSupplier = this.allSuppliers.filter(function (item) {
          //   return item.id ===user.supplierId;
          // });
         // this.supplierDetails = getSupplier[0];
         // this.onChangeSupplier(this.supplierDetails.id)
          //this.isUserSupplier = true;
          //this.gridShowHide = true;
        } else {
          this.isUserSupplier = false;
        }
        if(user.roleId === 1 || user.roleId === 3 || user.roleId === 4){
         
          this.showDeleteBtn = true;
        }else{
          
          this.showDeleteBtn = false;
        }
      });
  };

  private supplierInitForms(): void {
    this.suppliersForm = this.fb.group({
      supplier: [""],
      searchBox: [""],
    });
   this.suppliersOnChanged();
  };

  private getSupplierSelectedHandler(item):void {
    this.supplierDetails = item;
    this.gridShowHide = true;    
  };

  private setResetBreadcrumb() :void {
    if (this.foldersGrid) {
      this.documentsService.breadCrumb$
        .pipe(takeUntil(this.unsubscribe))
        .subscribe((data: string[]) => {
          this.breadCrumb = data;
        });
    } else {
      this.breadCrumb;
    }
  };

  private suppliersOnChanged():void{
    this.suppliersForm.valueChanges
    .pipe(debounceTime(500), distinctUntilChanged())
    .subscribe((obj) => {
      if (obj.searchBox) {
        this.supplierResults = this.allSuppliers.filter(
          (x) =>
            x.supplierName
              .toString()
              .toLowerCase()
              .indexOf(obj.searchBox.toString().toLowerCase()) > -1 ||
              x.organizationCode
              .toString()
              .toLowerCase()
              .indexOf(obj.searchBox.toString().toLowerCase()) > -1
        );
      } else if (this.supplierResults.length === 0 && obj.searchBox) {
        this.supplierResults = this.allSuppliers.filter(
          (x) =>
            x.organizationCode
              .toString()
              .toLowerCase()
              .indexOf(obj.searchBox.toString().toLowerCase()) > -1
        );
      } else {
        this.supplierResults = this.allSuppliers;
      }
      
      if (obj.supplier && this.foldersGrid) {
        this.supplierDetails = obj.supplier;
        this.uploadFileForm.controls.supplier.setValue(obj.supplier);
        this.getSupplierSelectedHandler(this.supplierDetails);
        this.foldersGrid = true;
      } else {
        
        this.uploadFileForm.controls.supplier.setValue(this.supplierDetails);
        this.foldersGrid = true;
      }
    
    });

  this.uploadFileForm.controls.supplier.valueChanges
    .pipe(debounceTime(500), distinctUntilChanged())
    .subscribe((objSup) => {
      if (objSup) {        
        this.suppliersForm.controls.supplier.setValue(objSup);
        this.supplierDetails = objSup;
        this.getSupplierSelectedHandler(this.supplierDetails);
        let getDom:HTMLCollectionOf<Element>=document.getElementsByClassName('mat-select-min-line');  
        getDom[1].innerHTML=this.supplierDetails.supplierName;
          this.onChangeSupplier(objSup.id);
        if(this.foldersViewComponent != undefined) {
        this.foldersViewComponent.restoreState(0);
        }
      }
    });
  };
   onChangeSupplier(id){    
    this.documentsService
      .getDocumentsFolder(id)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        (response) => {
          if(response) {
            this.folderStructure=response;
            this.shareDataService.emitfolderStructure(response);    
          }
               
        })

  }
 private registerNotificationView():void{
    this.userRepositoryService.notoficationDocSelected
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((item) => {
        if(item){
          const obj = this.supplierResults.filter(
            (x) => x.organizationCode === item.supplierCode
          );
          this.uploadFileForm.controls.supplier.patchValue(obj[0]);          
         }
      });
  }
}
